import { PaginatedApiPayloadV2, PaginationParams } from 'domain/Common';
import { EventGuest, ListedEventGuest } from 'domain/event';

export const mapPaginatedEventGuestsFromApi = (
  payload: PaginatedApiPayloadV2<ListedEventGuest>
): PaginatedApiPayloadV2<EventGuest> => ({
  ...payload,
  data: mapConnectionsFromApi(payload.data),
});

export const mapConnectionsFromApi = (data: ListedEventGuest[]): EventGuest[] => data;

export type EventGuestsSortBy = 'DISPLAY_NAME' | 'ROLE' | 'EMAIL';

export const mapSortParam = (param: string): EventGuestsSortBy | undefined => {
  switch (param) {
    case 'displayName':
      return 'DISPLAY_NAME';
    case 'role':
      return 'ROLE';
    case 'email':
      return 'EMAIL';
    default:
      return undefined;
  }
};

export const mapGetEventGuestsParams = ({ page, pageSize, sortBy, sortOrder }: PaginationParams) => ({
  page,
  pageSize,
  sortParam: mapSortParam(sortBy),
  sortDir: sortOrder,
});
